/**
 * Service Controller — Workspace "Công việc hôm nay"
 * Contract: TimesschoolsLA/ba-shared/api-contracts/task/task-workspace.md (v1.0)
 * Quyền: TSK0. Khối đơn duyệt/email server tự lọc theo quyền (APL5/TKA/EM0) —
 * không quyền trả khối rỗng, KHÔNG lỗi.
 */

import { request } from '../../utils/apiUtils';
import { URL_API } from '../../url.config';

const BASE_URL = `${URL_API}/api/sas-school/workspace`;

const WorkspaceController = {
    /** Màn "Hôm nay": bucket task + đơn chờ duyệt + email chưa đọc */
    today: (callback) => {
        return request({ url: `${BASE_URL}/today`, method: 'GET' }, callback);
    },

    /** Badge đếm gọn cho menu: { taskCount, approvalCount, emailUnreadCount, total } */
    badge: (callback) => {
        return request({ url: `${BASE_URL}/badge`, method: 'GET' }, callback);
    },
};

export default WorkspaceController;
